import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const pathToTitle = {
        "/login": "HaawkAI / login",
        "/signup": "HaawkAI / signup",
        "/verification": "HaawkAI / verification",
        "/forgotpassword": "HaawkAI / forgot-password",
        "/terms-of-service": "HaawkAI / terms-of-service",
        "/privacy-policy": "HaawkAI / privacy-policy",
        "/reset-password": "HaawkAI / Reset Password",
        "/profile": "HaawkAI / Profile",
        "/doc-ai/invoice": "HaawkAI / Invoice",
        "/doc-ai/aadhar-card": "HaawkAI / Aadhar Card",
        "/doc-ai/pan": "HaawkAI / PAN",
        "/doc-ai/gst-certificate": "HaawkAI / GST Certificate",
        "/doc-ai/business-card": "HaawkAI / Business Card",
        "/doc-ai/credit-card": "HaawkAI / Credit Card",
        "/doc-ai/id-document": "HaawkAI / ID Document",
        "/doc-ai/bank-cheque": "HaawkAI / Bank Cheque",
        "/doc-ai/eway-bill": "HaawkAI / Eway Bill",
        "/doc-ai/receipt": "HaawkAI / Receipt",
        "/doc-ai/bank-passbook": "HaawkAI / Bank Passbook",
        "/doc-ai/general-document": "HaawkAI / General Document",
        "/my-ai/criminal-document": "HaawkAI / Criminal Document",
        "/vision-ai/face-detection": "HaawkAI / Face Detection",
        "/vision-ai/liveness-detection": "HaawkAI / Liveness Detection",
        "/vision-ai/product-deduction": "HaawkAI / Product Deduction",
        "/vision-ai/image-search": "HaawkAI / Image Search",
        "/vision-ai/video-search": "HaawkAI / Video Search",
        "/vision-ai/video-summary": "HaawkAI / Video Summary",
        "/subscription": "HaawkAI / Subscription",
        "/my-usage": "HaawkAI / My Usage",
        "/my-ai/criminal-document/preview/:id": "HaawkAI / Criminal Document",
        "/doc-ai/aadhar-card/preview/:id": "HaawkAI / Aadhar Card",
        "/doc-ai/invoice/preview/:id": "HaawkAI / Invoice",
        "/doc-ai/pan/preview/:id": "HaawkAI / PAN",
        "/doc-ai/gst-certificate/preview/:id": "HaawkAI / GST Certificate",
        "/doc-ai/business-card/preview/:id": "HaawkAI / Business Card",
        "/doc-ai/id-document/preview/:id": "HaawkAI / ID Document",
        "/doc-ai/bank-cheque/preview/:id": "HaawkAI / Bank Cheque",
        "/doc-ai/eway-bill/preview/:id": "HaawkAI / Eway Bill",
        "/doc-ai/receipt/preview/:id": "HaawkAI / Receipt",
        "/doc-ai/bank-passbook/preview/:id": "HaawkAI / Bank Passbook",
        "/doc-ai/general-document/preview/:id": "HaawkAI / General Document",
        "/user-management": "HaawkAI / User Management",
    };


    let pageTitle = "HaawkAI"; 

    // Check for exact path match first
    if (pathToTitle[location.pathname]) {
      pageTitle = pathToTitle[location.pathname];
    } else {
      // Handle dynamic paths with parameters
      for (const path in pathToTitle) {
        if (path.includes(":id")) {
          const regex = new RegExp("^" + path.replace(":id", "(.+)") + "$");
          const match = location.pathname.match(regex);
          if (match) {
            pageTitle = pathToTitle[path];
            break;
          }
        }
      }
    }

    document.title = pageTitle;
  }, [location]);

  return null; // This component does not render anything
};

export default PageTitle;
